import VersionImportController from "./VersionImportController";

export default VersionImportController;
